import React from 'react';
import { PayMode } from 'services/reportsApi';
import { RefundsSummary as RefundsSummaryType } from './summarize';

interface Props {
  summary: RefundsSummaryType;
}

const fmtMoney = (n: number): string =>
  `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const PAY_MODE_LABEL: Record<PayMode, string> = {
  ach: 'ACH',
  check: 'Check',
  debit_card: 'Debit card',
  digital_check: 'Digital check',
};

const PAY_MODE_ORDER: PayMode[] = ['check', 'ach', 'debit_card', 'digital_check'];

export const RefundsSummary: React.FC<Props> = ({ summary }) => {
  const activeModes = PAY_MODE_ORDER.flatMap((mode) => {
    const bucket = summary.by_pay_mode[mode];
    return bucket ? [{ mode, bucket }] : [];
  });

  return (
    <div className="flex w-full flex-col gap-2 rounded-lg border-l-4 border-primary-300 bg-white p-4 shadow-analyticsCard">
      <div className="flex flex-wrap items-baseline gap-3">
        <span className="text-12s uppercase tracking-wide text-gray-500">Total refunded</span>
        <span className="text-24s font-bold text-gray-900">{summary.count}</span>
        <span className="text-18s text-gray-700">{fmtMoney(summary.total_amount)}</span>
      </div>
      {activeModes.length > 0 && (
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-14s text-gray-600">
          <span className="text-12s uppercase tracking-wide text-gray-500">By mode:</span>
          {activeModes.map(({ mode, bucket }) => (
            <span key={mode} data-testid={`summary-mode-${mode}`}>
              {PAY_MODE_LABEL[mode]} {bucket.count}/{fmtMoney(bucket.total_amount)}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default RefundsSummary;
